import TemplatesList from '../components/TemplatesList';
import {ManifestDto} from '../api/rest/template/ManifestDto';
import {Alert, Button, Card, Col, Form, Row, Spinner} from 'react-bootstrap';
import ApiClientFactory from '../api/rest/template/TemplatesApiClientFactory';
import React, {useEffect, useState} from 'react';
import {TemplateDto} from '../TemplateDto';
import {TemplateFormModal} from '../components/TemplateFormModal';
import {useLocation, useNavigate} from 'react-router-dom';
import {SearchResultDto} from '../api/rest/template/SearchResultDto';

export default function SearchPage() {
    const getCurrentOptions = (filter: string): string[] => {
        return new URLSearchParams(location.search).getAll(filter);
    };
    const navigate = useNavigate();
    const location = useLocation();
    const [template, setTemplate] = useState<TemplateDto>();
    const [searchResult, setSearchResult] = useState<SearchResultDto>({manifests: [], facets: []});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const qParam = params.get('q') || '';
        const tags = params.getAll('tag') || [];

        ApiClientFactory.getTemplatesApiClient()
            .search(qParam, tags)
            .then((searchResult) => setSearchResult(searchResult))
            .catch((err: unknown) => {
                console.error(err);
                setError('Failed to load templates.');
            })
            .finally(() => setLoading(false));
    }, [location.search]);

    if (loading)
        return (
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        );
    if (error) return <Alert variant="danger">{error}</Alert>;

    const repoName = 'solidify';

    const handleGenerateClicked = (manifest: ManifestDto) => {
        let templatesApiClient = ApiClientFactory.getTemplatesApiClient();
        templatesApiClient.getTemplateSchema(repoName, manifest.name).then((schemaResponse) => {
            templatesApiClient.getTemplateDefaults(repoName, manifest.name).then((defaultsResponse) => {
                setTemplate({
                    manifest: manifest,
                    schema: schemaResponse,
                    defaults: defaultsResponse,
                });
            });
        });
    };

    const selectedTags = getCurrentOptions('tag');
    const filterOptions = {
        tag: searchResult.facets.length > 0 ? searchResult.facets[0].options : [],
        license: [],
    };

    const handleCheckboxChange = (tag: string, isChecked: boolean) => {
        const currentTags = getCurrentOptions('tag');
        let updatedTags: string[];

        if (isChecked) {
            // Dodaj tag, jeśli nie istnieje
            updatedTags = [...new Set([...currentTags, tag])];
        } else {
            // Usuń tag
            updatedTags = currentTags.filter((t) => t !== tag);
        }

        // Aktualizuj URL
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete('tag');
        updatedTags.forEach((t) => searchParams.append('tag', t));
        navigate(
            {
                pathname: location.pathname,
                search: searchParams.toString(),
            },
            {replace: false},
        );
    };

    return (
        <>
            <Row>
                <Col sm={3}>
                    <Card style={{minHeight: '400px'}}>
                        <Card.Body className={'mx-3 '}>
                            <h6 className={'my-3 fs-1'} style={{textTransform: 'uppercase'}}>
                                FILTERS
                            </h6>
                            <hr />
                            {Object.entries(filterOptions).map(([filterKey, options]) => (
                                <div key={filterKey}>
                                    <h6 className={'my-3 fw-bold'} style={{textTransform: 'uppercase'}}>
                                        {filterKey}
                                    </h6>
                                    {options.map((option) => {
                                        return (
                                            <Form.Check
                                                className="my-0 py-0"
                                                key={option.name}
                                                type="checkbox"
                                                label={option.name + ' (' + option.total + ') '}
                                                checked={selectedTags.includes(option.name)}
                                                onChange={(e) => handleCheckboxChange(option.name, e.target.checked)}
                                            />
                                        );
                                    })}
                                </div>
                            ))}
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={9}>
                    <TemplatesList manifests={searchResult.manifests}>
                        <TemplatesList.Actions>
                            {(manifest: ManifestDto) => (
                                <>
                                    <Button variant={'outline-info'} size="sm" className={"flex-fill"} onClick={() => handleGenerateClicked(manifest)}>
                                        View Details
                                    </Button>
                                    <Button variant={'primary'} size={"sm"} className={"flex-fill"} onClick={() => handleGenerateClicked(manifest)}>
                                        Generate
                                    </Button>
                                </>
                            )}
                        </TemplatesList.Actions>
                    </TemplatesList>
                </Col>
            </Row>
            <TemplateFormModal show={template != undefined} onClose={() => setTemplate(undefined)} template={template} />
        </>
    );
}
